<template>
  <footer>
      
  </footer>
</template>


<script>
export default {};
</script>


<style scoped>
footer {
    background-color:#3f3f3f;
    color: #d5d5d5;
}

footer h5{
  color: orange;
}

ul li{
    list-style: none;
}

ul li a{
   color:#fff;
}

.social a{
  font-size: 4.0em;
  padding: 1rem;
}

.fa-facebook{
  color: #3b5998;
}

.fa-twitter{
  color: #00aced;
}

.fa-instagram{
  color: #517fa4;
}

.fa-instagram:hover,
.fa-twitter:hover,
.fa-facebook:hover
{
  color: #d5d5d5;
}
</style>
